export default [
  [
    {
      types: "Pedestre",
      quantidade: 50,
      values: [1],
      selected: false,
      name: "Trab_PPL_1",
    },
    {
      types: "Ciclista",
      quantidade: 50,
      values: [2],
      selected: false,
      name: "Trab_PPL_2",
    },
    {
      types: "Motociclista",
      quantidade: 50,
      values: [3],
      selected: false,
      name: "Trab_PPL_3",
    },
    {
      types: "Pedestre + Ciclista",
      quantidade: 25,
      values: [1, 2],
      selected: false,
      name: "Trab_PPL_4",
    },
    {
      types: "Pedestre + Motociclista",
      quantidade: 25,
      values: [1, 3],
      selected: false,
      name: "Trab_PPL_5",
    },
    {
      types: "Ciclista + Motociclista",
      quantidade: 25,
      values: [2, 3],
      selected: false,
      name: "Trab_PPL_6",
    },
  ],
  [
    {
      types: "Pedestre",
      quantidade: 32,
      values: [1],
      selected: false,
      name: "Trab_PPL_7",
    },
    {
      types: "Ciclista",
      quantidade: 32,
      values: [2],
      selected: false,
      name: "Trab_PPL_8",
    },
    {
      types: "Motociclista",
      quantidade: 32,
      values: [3],
      selected: false,
      name: "Trab_PPL_9",
    },
  ],
  [
    {
      types: "Pedestre",
      quantidade: 20,
      values: [1],
      selected: false,
      name: "Trab_PPL_10",
    },
    {
      types: "Ciclista",
      quantidade: 20,
      values: [2],
      selected: false,
      name: "Trab_PPL_11",
    },
    {
      types: "Motociclista",
      quantidade: 20,
      values: [3],
      selected: false,
      name: "Trab_PPL_12",
    },
  ],
  [
    {
      types: "Pedestre",
      quantidade: 40,
      values: [1],
      selected: false,
      name: "Est_PPL_1",
    },
    {
      types: "Ciclista",
      quantidade: 40,
      values: [2],
      selected: false,
      name: "Est_PPL_2",
    },
    {
      types: "Motociclista",
      quantidade: 40,
      values: [3],
      selected: false,
      name: "Est_PPL_3",
    },
    {
      types: "Pedestre + Ciclista",
      quantidade: 20,
      values: [1, 2],
      selected: false,
      name: "Est_PPL_4",
    },
    {
      types: "Pedestre + Motociclista",
      quantidade: 20,
      values: [1, 3],
      selected: false,
      name: "Est_PPL_5",
    },
    {
      types: "Ciclista + Motociclista",
      quantidade: 20,
      values: [2, 3],
      selected: false,
      name: "Est_PPL_6",
    },
  ],
  [
    {
      types: "Pedestre",
      quantidade: 25,
      values: [1],
      selected: false,
      name: "Est_PPL_7",
    },
    {
      types: "Ciclista",
      quantidade: 25,
      values: [2],
      selected: false,
      name: "Est_PPL_8",
    },
    {
      types: "Motociclista",
      quantidade: 25,
      values: [3],
      selected: false,
      name: "Est_PPL_9",
    },
  ],
  [
    {
      types: "Pedestre",
      quantidade: 16,
      values: [1],
      selected: false,
      name: "Est_PPL_10",
    },
    {
      types: "Ciclista",
      quantidade: 16,
      values: [2],
      selected: false,
      name: "Est_PPL_11",
    },
    {
      types: "Motociclista",
      quantidade: 16,
      values: [3],
      selected: false,
      name: "Est_PPL_12",
    },
  ],
]
